document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.collection-carousel');

    carousels.forEach(container => {
        const slider = container.querySelector('[data-carousel]');
        const dots = [...container.querySelectorAll('.navigation-dot')];
        if (!dots.length) return;

        const updateActiveDot = () => {
            const children = slider.children.length;
            const scrollFraction = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth || 1);
            const activeIndex = Math.round(scrollFraction * (children - 1));
            dots.forEach((dot, i) => dot.classList.toggle('is-selected', i === activeIndex));
        };

        slider.addEventListener('scroll', updateActiveDot);

        dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
                const children = slider.children.length;
                const targetScroll = (slider.scrollWidth - slider.clientWidth) * (i / (children - 1));
                slider.scrollTo({ left: targetScroll, behavior: 'smooth' });
            });
        });

        updateActiveDot();
    });
});